import styled from 'styled-components';
import { defaultShadow } from '../../styles/global';

export const ChangeLanguageContainer = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  :hover {
    transform: scale(1.1);
  }

  > img {
    width: 2.5rem;
    height: 2.5rem;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
`;

export const ModalContent = styled.div`
  background-color: ${(props) => props.theme.colors.surface};
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }

  h3 {
    margin: 0 0 1rem 0;
    color: ${(props) => props.theme.colors.onSurface};
    text-align: center;
    font-size: 1.1rem;
  }
`;

export const LanguageOption = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 0.8rem 1rem;
  border: none;
  background-color: ${(props) => props.active ? props.theme.colors.background : 'transparent'};
  color: ${(props) => props.active ? props.theme.colors.primary : props.theme.colors.onSurface};
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;

  /* Remove default button border/outline */
  outline: none;

  &:hover {
    background-color: ${(props) => props.theme.colors.background};
    /* ${defaultShadow} */
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  img {
    width: 1.8rem;
    height: 1.8rem;
    object-fit: cover;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
    font-weight: bold;
  }
`;

export default ChangeLanguageContainer;
